import SelectAllCheckbox from '../components/SelectAllCheckbox'

export default class UserAssignedAds {
  constructor(params) {
    this.selectCheckbox = new SelectAllCheckbox();
  }

  index() {
    N2.bindHandler('change', "input[type=checkbox]", (e) => {
      this.selectCheckbox.changeBackgroundColor();
      this.selectCheckbox.checkUiStates();
    });
  }
}
